import React, { useState, useEffect } from 'react';
import { ConfigProvider } from 'antd';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import { Outlet } from 'react-router-dom';
import { LocalStorageService } from '../../../configuration';
import { isViewerOnly } from '../../../utils/admin-permissions';
import { useDarkMode } from '../../../hooks/use-dark-mode/use-dark-mode.hook';
import ViewerBanner from '../components/ViewerBanner';
import { getAdminTheme } from '../ui/admin-theme';
import '../ui/admin.css';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isDarkMode, toggleTheme } = useDarkMode();
  const accessToken = LocalStorageService.getItem('cmsAccessToken');
  useEffect(() => {
    const checkUserRole = () => {
      if (!accessToken) {
        window.location.href = '/admin/login';
        return;
      }
      try {
        const payload = JSON.parse(atob(accessToken.split('.')[1]));
        const roles = payload.Role;
        // Cho phép mọi vai trò quản trị vào panel (Admin/SuperAdmin/Mod/Kế toán/Staff) —
        // backend + menu tự giới hạn theo quyền. Chỉ User thuần thì không vào.
        const adminRoles = ['ADMIN', 'SUPERADMIN', 'MOD', 'ACCOUNTANT', 'STAFF', 'MONETIZATION', 'VIEWER'];
        if (
          !Array.isArray(roles) ||
          !roles.map((role) => role.toUpperCase()).some((r) => adminRoles.includes(r))
        ) {
          window.location.href = '/admin/login';
        }
      } catch (error) {
        console.error('Error decoding token or accessing role:', error);
        window.location.href = '/admin/login';
      }
    };

    checkUserRole();
  }, [accessToken]);

  return accessToken ? (
    // Theme antd riêng cho admin (màu chính, bo góc, nút viên thuốc, đầu bảng) — lồng trong ConfigProvider gốc
    // nên vẫn giữ locale tiếng Việt; thuật toán sáng/tối theo công tắc ở thanh trên.
    <ConfigProvider theme={getAdminTheme(!!isDarkMode)}>
      <div className="adm-root">
        <div className="adm-shell">
          <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

          <div className="adm-content">
            <Header
              sidebarOpen={sidebarOpen}
              setSidebarOpen={setSidebarOpen}
              isDark={!!isDarkMode}
              onToggleDark={toggleTheme}
            />

            <main className="admin-shell adm-main">
              {isViewerOnly() && <ViewerBanner />}
              <Outlet />
            </main>
          </div>
        </div>
      </div>
    </ConfigProvider>
  ) : null;
};

export default AdminLayout;
